import './components.css';

const DeVlietPost = () => {
    return (
        <div className='custom-body'>
            <div className='card h-100 custom-card'>
                <img
                    src='./img-intern/wzc-de-vliet.jpg'
                    alt='WZC De Vliet'
                    className='card-img-top post-img'
                />
                <div className='card-body'>
                    <h5 className='card-title'>WZC De Vliet</h5>
                    <div className='card-text'>
                        Waar we woonzorgverblijf, kortverblijf en zorgverblijf voor
                        personen met een niet-aangeboren hersenletsel aanbieden.
                    </div>
                    <a
                        href='https://www.zorgnetwerktrento.be/onze-dienstverlening'
                        target='_top'
                        className='btn btn-primary stretched-link'
                    >
                        Lees Meer
                    </a>
                </div>
            </div>
            <p className='adres'>Het adres is Koevliet 8, 9240 Zele.</p>
            <iframe
                title='Locatie WZC De Vliet'
                src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2507.2711521337005!2d4.024252551367345!3d51.06654445056092!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c39a62ef41c0a3%3A0xa90992dbc69bfe14!2sKoevliet%208%2C%209240%20Zele!5e0!3m2!1snl!2sbe!4v1617620022105!5m2!1snl!2sbe'
                width='400'
                height='250'
                style={{ border: '0' }}
                allowfullscreen=''
                loading='lazy'
            ></iframe>
        </div>
    );
};

export default DeVlietPost;
